module.exports = __webpack_public_path__ + "img/miranda.893e5dca.jpg";